import React, { createElement } from 'react';

export function ProductItem({ hit, components }) {
    return (
        <>
            <a href={`/users/${hit.user}`} className="aa-ItemLink">
                <div className="aa-ItemContent">
                    <div className="aa-ItemTitle">
                        <components.Highlight hit={hit} attribute="profile_name" />
                    </div>
                </div>
            </a>
        </>
    );
}
